// @flow

import React from 'react'
import { useSelector } from 'react-redux'

import { isMobile } from 'react-device-detect'

import 'animate.css'

function Breadcrumb({ options }) {
	const { showCartMenu } = useSelector((state) => state.action)

	const { headerClass, title } = options

	return (
		<div
			className={`topStatus animate__animated animate__fadeInDown ${
				showCartMenu && isMobile ? 'd-none' : ''
			}`}
		>
			<span>
				<div className={'icon'}>
					<i className="icons-breadcrumb-cart"></i>
				</div>
				<div className={`statusText ${headerClass}`}>{title}</div>
			</span>
		</div>
	)
}

export default Breadcrumb
